import { Component, Input, Output, EventEmitter } from '@angular/core'
import { HelperService } from '../../services/helper.service'
import { SortingModel } from '../../models/sorting.model'

@Component({
    selector: 'app-breadcrumbs-filter',
    templateUrl: './breadcrumbs-filter.component.html',
    styleUrls: ['./breadcrumbs-filter.component.scss'],
    standalone: false
})
export class BreadcrumbsFilterComponent {
  @Input() filter: any
  @Input() filterMap: any
  @Input() ignore: string[] = []
  @Input() sid: number | null
  @Input() sort: SortingModel | null
  @Input() clearfix: boolean = true

  @Output() filterChangeEvent: EventEmitter<any> = new EventEmitter<{ filter: any; key: any }>()
  @Output() filterRemoveEvent: EventEmitter<any> = new EventEmitter<any>()
  @Output() sortRemoveEvent: EventEmitter<any> = new EventEmitter<any>()

  public clearAll(): void {
    this.filterRemoveEvent.emit()
  }

  public clearFilterKey(key: any): void {
    this.filter[key] = null
    this.filterChangeEvent.emit({ filter: this.filter, key: key })
  }

  public clearSorting(): void {
    this.sort = null
    this.sortRemoveEvent.emit()
  }

  public displayFilter(item: { key: any; value: any }): boolean {
    if (this.ignore.indexOf(item.key) !== -1) {
      return false
    }
    
    if (Array.isArray(item.value) && item.value.length === 0) {
      return false
    }

    return !HelperService.isNullOrUndefined(item.value);
  }

  public keyToLabel(key: any): string {
    return this.filterMap && this.filterMap[key] ? this.filterMap[key] : key
  }

  public hasFilters(): boolean {
    if (this.filter) {
      for (const key of Object.keys(this.filter)) {
        if (this.displayFilter({ key: key, value: this.filter[key] })) {
          return true
        }
      }
    }
    return false
  }

  public hasSort(): boolean {
    return !!this.sort && !!this.sort.direction
  }

  public getSortIcon(): string | null {
    if (this.sort) {
      if (this.sort.direction === 'desc') {
        return 'fas fa-sort-amount-down'
      }
      return 'fas fa-sort-amount-up-alt'
    }
    return null
  }
}
